import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/api';
import { UserStoreDivision } from '../../../models/store-common.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { StoreCommonService } from '../../../services/store/store-common.service';
import { KontableComponent } from "../../../modules/UIKit/components/kontable/kontable.component";
import { UserStoreDivisionService } from 'app/services/store/user-store-division.service';

@Component({
  selector: 'app-user-store-division',
  templateUrl: './user-store-division.component.html'
})
export class UserStoreDivisionComponent implements OnInit {
  selectFilter = KontableComponent.SelectFilter;
  paginationType = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;

  @ViewChild('table') table: KontableComponent;
  titles: DataTableField[];
  showDetail = false;
  common = {};
  modalTitle = '';
  scope: SelectItem[] = [{label: "All", value: null}, {label: "Loyalty", value: "loyalty"}];
  notSpecTitle: string = '';

  constructor(
    public svc: StoreCommonService,
    public userStoreDivisionService: UserStoreDivisionService,
    private translate: TranslateService,
    private srvDataTable: DataTableService
  ) {

    this.translate.get([
      'common.store_name',
      'common.store_description',
      'common.username',
      'userStoreDivision.add_title',
      'userStoreDivision.edit_title']).subscribe(res => {
        this.titles = [
          { id: 'id', label: '#' },
          { id: 'store_name', label: res['common.store_name'] },
          { id: 'division_name', label: res['common.division'] },
          { id: 'username', label: res['common.username'] },
        ]

        this.common['add_title'] = res['userStoreDivision.add_title'];
        this.common['edit_title'] = res['userStoreDivision.edit_title'];
       
    });

  }

  ngOnInit() {
    this.translate.get([
      'reservations.catalog',
      'common.notSpecified'
    ]).subscribe( res => {
      this.scope.push({label: res['reservations.catalog'], value: "catalog"});
      this.scope.push({label: res['common.notSpecified'], value: null});
      this.notSpecTitle = res['common.notSpecified'];
    });

    //this.reloadList()
  }

  reloadList() {
    this.table.refresh();
    this.showDetail = false;
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.common['add_title'] : this.common['edit_title'];
    this.svc.editing_user_store_division = data == null ? new UserStoreDivision() : data;
    this.showDetail = true;
  }

  delete(record): void {
    this.svc.deleteUserStoreDivisions(record['id']).subscribe(() => {
      this.reloadList();
    });
  }

  recover(record): void {
    this.svc.recoverUserStoreDivisions(record['id']).subscribe(() => {
      this.reloadList();
    });
  }

  onAddElement(entry): void {
    this.svc.postUserStoreDivision(entry).subscribe(() => {
      this.srvDataTable.get('dt_usd').showDetail = false;
      this.svc.editing_user_store_division = null;
      this.reloadList();
    });

  }


  onUpdateElement(entry): void {
    this.svc.putUserStoreDivision(this.svc.editing_user_store_division.id, entry).subscribe(() => {
        this.srvDataTable.get('dt_usd').showDetail = false;
        this.svc.editing_user_store_division = null;
        this.reloadList();
      }
    )
  }

  onDialogHide () {
    this.svc.editing_user_store_division = null;
    this.reloadList();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/user-store-division/user-store-division.component.ts